import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ToggleButton from './commons/ToggleButton';

/**
 * @type {import('react').CSSProperties}
 */
const align = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

function HideControlCheckBox(props) {
  const onChange = (flag) => {
    props.onChange(flag);
  };

  return (
    <div style={align}>
      <ToggleButton
        true={<FontAwesomeIcon icon="eye" />}
        false={<FontAwesomeIcon icon="eye-slash" />}
        onChange={onChange}
      ></ToggleButton>
    </div>
  );
}

export default HideControlCheckBox;
